import React,{Component} from 'react'
import { Layout, Menu, Icon,Avatar,} from 'antd';
import {Link,withRouter} from 'react-router-dom'

import authorizeBase from "../authorize/authorizeBase";


import SiderLogo from '../../assets/images/siderLogo.png'
import userUtils, {getUserInfo} from "../../utills/userUtils";

const AuthMenuItem = authorizeBase(Menu.Item)
const {Sider,} = Layout;

class SiderMenu extends Component{
    constructor(props){
        super(props);
        this.state={}
    }
    componentWillMount() {
        getUserInfo().then((userInfo)=>{
            this.setState({
                name:userInfo.name,
                authCode:userInfo.authCode,
            })
        })
    }

    render() {
        const path = this.props.location.pathname
        return (
                <Sider trigger={null} collapsible collapsed={false} style={{overflowY: 'auto',background:'#fff'}}>
                    <div className='siderLogo' style={{background:'#2975d5',height:'57px',lineHeight:'57px',padding:'0 10px'}}>
                        <a href='http://47.105.147.107'>
                            <img src={SiderLogo} alt="SiderLogo" style={{width:'100%'}}/>
                        </a>
                    </div>
                    <div className="sliderUser">
                        <div className='sider-user-info'>
                            <Avatar size={64} icon="user"  className='siderAvatar'/>
                            <span className='sider-userName' onDoubleClick={()=>{userUtils.resetUserInfo()}}>{this.state.name}</span>
                        </div>
                        <div className='sider-user-set'>
                        <span>
                             <Icon type="user"  className='sider-info-icon'/>
                            <span className='sider-userName'>授权码：{this.state.authCode}</span>
                        </span>
                            {/*<span>
                             <Icon type="setting"  className='sider-info-icon'/>
                            <span className='sider-userName'>账号设置</span>
                        </span>*/}
                        </div>
                    </div>
                    <Menu theme="white" mode="inline" defaultSelectedKeys={[path]} selectedKeys={[this.props.history.location.pathname]}>
                        <AuthMenuItem className='sider-nav-item' key="/" authority="page:index">
                            <Link to='/'>
                                <Icon type="home" />
                                <span>首页</span>
                            </Link>
                        </AuthMenuItem>
                        <AuthMenuItem className='sider-nav-item' key="/trackList" authority="order:edit">
                            <Link to='/trackList'>
                                <Icon type="unordered-list" />
                                <span>我的委托单</span>
                            </Link>
                        </AuthMenuItem>
                        <AuthMenuItem className='sider-nav-item' key="/deliveryList" authority="delivery:edit">
                            <Link to='/deliveryList'>
                                <Icon type="unordered-list"/>
                                <span>物流信息维护</span>
                            </Link>
                        </AuthMenuItem>
                        <AuthMenuItem className='sider-nav-item' key="/addrList" authority="address:edit">
                            <Link to='/addrList'>
                                <Icon type="unordered-list"/>
                                <span>地址管理</span>
                            </Link>
                        </AuthMenuItem>
                        <AuthMenuItem className='sider-nav-item' key="/companyUpdate" authority="company:edit">
                            <Link to='/companyUpdate'>
                                <Icon type="unordered-list"/>
                                <span>企业信息</span>
                            </Link>
                        </AuthMenuItem>
                    </Menu>
                </Sider>
        )
    }
}
export default withRouter(SiderMenu)